<template>
  <!-- 人才招聘 -->
  <div class="recruit">
    <Banner
      ref="cBanner"
      :banner_img="resBanners"
      banner_en="TALENT positionName"
      banner_cn="人才招聘"
    >
    </Banner>
    <div class="contain mainBody">
      <!-- 人才战略介绍 -->
      <div class="agency marginT60">
        <recruitTit
          cn="人才战略介绍"
          en="TALENT STRATEGY INTRODUCTION"
        ></recruitTit>
        <div class="agency_line clear">
          <div class="agency_txt">
            <p>
              梧州黄埔化工药业有限公司一直秉承“发展是第一要务、人才是第一资源”的理念。完善人才选聘制度，注重配置人才资源，努力实现“人尽其才、才尽其用”。透过现代人力资源管理实践，挖掘员工潜能、提升员工素质、优化人才结构，充分发挥引才、育才的平台作用，促进企业与员工的共同发展。
            </p>
            <p>
              企业从组织发展需求出发，围绕公司人才战略规划，建立长远的人才培养机制。根据公司发展需要制定培养方案，使员工不断进步，形成科学的人才队伍。
            </p>
          </div>
          <div class="agency_img">
            <img src="../assets/images/recruit/devimg.png" />
          </div>
        </div>
      </div>
      <!-- 岗位招聘 -->
      <div class="mainBody wow fadeInUp animated marginT40">
        <recruitTit cn="招聘岗位" en="RECRUITING POSITION"></recruitTit>
        <ul class="recruitingNav">
          <li
            v-for="(item, index) in recruitingNav"
            :class="[index == navindex ? 'on' : '']"
            :key="index"
            @click="OnChangeRecruiting(index)"
          >
            {{ item.tit }}
          </li>
        </ul>
        <ul class="recruitlist clear marginT30">
          <div class="notRecruit" v-if="recruitList.length <= 0">
            暂无招聘计划~
          </div>
          <li
            v-for="(item, index) in recruitList"
            :key="'recruit' + index"
            @click="OnViewRecruitDetails(item)"
          >
            <div class="recruitlist_name">
              招聘职位：{{ item.positionName }}
            </div>
            <div class="recruitlist_line">
              <div class="recruitlist_line_p">
                <span>工作城市：</span> {{ item.workingPlace }}
              </div>
              <div class="recruitlist_line_p">
                <span>学历要求：</span> {{ item.degreeRequired }}
              </div>
              <div class="recruitlist_line_p">
                <span>招聘人数： </span> {{ item.recruitCount }}人
              </div>
            </div>
            <div class="recruitlist_btm clear">
              <div class="recruitlist_btm_left">
                更新时间：{{ item.updateTime }}
              </div>
              <div class="recruitlist_btm_right">
                <span>查看详情</span>
                <div class="recruitlist_btm_right_jt"></div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <div class="pagecon">
          <el-pagination
            :hide-on-single-page="recruitList.length <= 6"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total"
            @size-change="getPage"
            @current-change="getPage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="outerVisible">
      <div slot="title" class="dialog-header">
        <div class="zpname">招聘岗位：{{ recruitDetailsObj.positionName }}</div>
        <div class="zprecruitCount">
          招聘人数：{{ recruitDetailsObj.recruitCount }}位
        </div>
      </div>
      <div class="dialog_content">
        <div class="dialog_tit">岗位要求:</div>
        <div class="dialog_txt" v-html="recruitDetailsObj.jobDesc"></div>
        <div class="dialog_tit marginT30">任职资格:</div>
        <div
          class="dialog_txt"
          v-html="recruitDetailsObj.jobResponsibility"
        ></div>
        <div class="dialog_tit marginT30">福利待遇:</div>
        <div class="dialog_txt" v-html="recruitDetailsObj.salary"></div>
        <div class="dialog_tit marginT30">联系投递:</div>
        <div class="dialog_txt clear">
          <div class="dialog_b_txt">
            投递邮箱：{{ recruitDetailsObj.deliverEmail }}
          </div>
          <div class="dialog_b_txt">
            联系人：{{ recruitDetailsObj.contactUser }}
          </div>
          <div class="dialog_b_txt">
            联系方式：{{ recruitDetailsObj.contactPhone }}
          </div>
          <div class="dialog_b_txt">
            工作地址：{{ recruitDetailsObj.contactAddress }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tooltip } from 'element-ui'
import Banner from '@/components/common/Banner.vue'
import recruitTit from '@/components/common/recruitTit.vue'

export default {
  data() {
    return {
      navindex: 0,
      outerVisible: false,
      recruitingNav: [{ tit: '社会招聘' }, { tit: '校园招聘' }],
      recruitList: [],
      textList: {
        shezhao: [
          // {
          //   positionName: "党工部副部长",
          //   workingPlace: "广西",
          //   degreeRequired: "本科及以上",
          //   recruitCount: "1",
          //   updateTime: "2021-03-08",
          //   jobDesc: `
          //   <p>1.执行上级的决议、决定，宣传党的路线、方针、政策，开展思想政治工作，开展精神文明建设活动；</p>
          //   <p>2.处理公司日常的党务工作，认真贯彻执行公司党组织决议，负责组织公司党组织开展的各项工作，制定公司党组织年度工作计划和工作活动安排；</p>
          //   <p>3.负责选人用人方面的干部提拔管理工作；</p>
          //   <p>4.负责干部人事档案以及党员档案的管理工作；</p>
          //   <p>5.协助做好企业文化建设、宣传稿件审核及抓好公司的意识形态工作；</p>
          //   <p>6.负责党组织的其他工作；</p>
          //   <p>7.协助做好党员发展、评议、考核、奖惩等工作；</p>
          //   <p>8.负责落实“三会一课”制度，协助召开民主生活会、党员组织生活会，组织政治学习、开展讨论、参观、访问、慰问、民主评议党员、党组织的换届选举工作、发展新党员，党风廉政建设工作、表彰先进等工作；</p>
          //   <p>9.抓好部门其他工作</p>
          //   <p>10.完成领导交办的其他工作。</p>
          //   `,
          //   jobResponsibility: `
          //   <p>1.中共党员，大学本科及以上学历，年龄35岁及以下；</p>
          //   <p>2.具备较扎实的文字功底；</p>
          //   <p>3.有5年以上国有企业或机关单位党务、组织人事、宣传工作经验；</p>
          //   <p>4.有较强的分析及解决问题能力，熟练使用办公软件等；</p>
          //   <p>4.责任心强，团结合作意识强。</p>
          //   `,
          //   salary: `
          //   <p>1.薪资7000-15000</p>
          //   <p>2.双休+法定节假日休假+年假</p>
          //   <p>3.公积金+社保</p>
          //   <p>4.餐补+交通补贴+住房补贴</p>
          //   `,
          //   deliverEmail: "wzhphg@163.com",
          //   contactUser: "古小姐",
          //   contactPhone: "0774-2065773",
          //   contactAddress: "梧州市万秀区梧松路1号",
          // },
          // {
          //   positionName: "安全环保部副部长",
          //   workingPlace: "广西",
          //   degreeRequired: "本科及以上",
          //   recruitCount: "1",
          //   updateTime: "2021-03-08",
          //   jobDesc: `
          //   <p>1.负责公司安全环保管理相关工作；</p>
          //   <p>2.负责组织宣传、贯彻、执行国家有关安全生产、环境保护、职业卫生、治安保卫、消防等方面的法律法规。协助部长完善相关管理制度保证公司安全生产，环境保护达标；</p>
          //   <p>3.负责组织安全员对生产车间现场管理工作、严抓现场管理中的“三违”人和事，确保生产车间现场安全管理常态化；</p>
          //   <p>4.负责定期组织公司全方位的安全环保检查，对安全生产中存在的危险源、高中度风险因素提出防范措施，制定紧急事件的应急预案，并监督实施；</p>
          //   <p>5.协助其他相关部门做好新员工上岗前安全教育培训工作，特殊工种持证上岗情况监督检查工作；</p>
          //   <p>6.完成公司领导安排的其他相关工作；</p>
          //   `,
          //   jobResponsibility: `
          //   <p>1.大专及以上学历，40周岁以下；</p>
          //   <p>2.熟悉安全生产、环境保护等相关法律法规；</p>
          //   <p>3.具备危化品生产企业安全环保管理5年及以上相关工作经验；</p>
          //   <p>4.具备较强的安全管控及应急处理能力；</p>
          //   <p>4.能吃苦耐劳。具备良好的职业道德和团队合作精神；</p>
          //   `,
          //   salary: `
          //   <p>1.薪资7000-15000</p>
          //   <p>2.双休+法定节假日休假+年假</p>
          //   <p>3.公积金+社保</p>
          //   <p>4.餐补+交通补贴+住房补贴</p>
          //   `,
          //   deliverEmail: "wzhphg@163.com",
          //   contactUser: "古小姐",
          //   contactPhone: "0774-2065773",
          //   contactAddress: "梧州市万秀区梧松路1号",
          // },
          // {
          //   positionName: "销售经理",
          //   workingPlace: "广西",
          //   degreeRequired: "本科及以上",
          //   recruitCount: "1",
          //   updateTime: "2021-03-08",
          //   jobDesc: `
          //   <p>1.根据市场情况和公司发展目标，协助制订公司年度销售计划；</p>
          //   <p>2.负责公司产品国内外销售，做好市场调研和需求分析；</p>
          //   <p>3.负责市场开发和回款，建立和维护销售网络和重要客户关系；</p>
          //   <p>4.负责审核新客户的资信和业务运营情况、建立客户档案；</p>
          //   <p>5.负责产品售后服务，记录、处理客户咨询与投诉，监督投诉处理执行情况；</p>
          //   `,
          //   jobResponsibility: `
          //   <p>1.大学本科及以上学历，化工或其他相关专业；</p>
          //   <p>2.年龄：30岁以下；</p>
          //   <p>3.具有较扎实的化工或相关专业基础知识；</p>
          //   <p>4.具有较强的市场分析和市场推广能力；</p>
          //   <p>5.具备良好的职业道德和沟通协调能力；</p>
          //   <p>6.具备较强的团队合作精神。</p>
          //   `,
          //   salary: `
          //   <p>1.薪资7000-15000</p>
          //   <p>2.双休+法定节假日休假+年假</p>
          //   <p>3.公积金+社保</p>
          //   <p>4.餐补+交通补贴+住房补贴</p>
          //   `,
          //   deliverEmail: "wzhphg@163.com",
          //   contactUser: "古小姐",
          //   contactPhone: "0774-2065773",
          //   contactAddress: "梧州市万秀区梧松路1号",
          // },
        ],
        xiaozhao: [],
      },
      recruitDetailsObj: {}, // 招聘详情内容
      total: 1, // 总数
      pageNo: 1, // 当前页
      pageSize: 5, // 每页显示条数
      resBanners: [
        // {
        //   imageUrl: require("../assets/images/recruit/banner.png"),
        //   skipHref: "",
        // },
      ],
    }
  },
  mounted() {
    this.getDataList()
    this.getBanners()
    this.recruitList = this.textList['shezhao']
    new this.$wow.WOW({
      live: false,
      offset: 0,
    }).init()
  },
  methods: {
    // 切换招聘类型
    OnChangeRecruiting(index) {
      this.navindex = index
      this.recruitList = this.textList[index === 0 ? 'shezhao' : 'xiaozhao']
      this.recruitList = []
      this.pageNo = 1
      this.getDataList()
    },
    // 展开详情
    OnViewRecruitDetails(data) {
      this.recruitDetailsObj = {}
      this.outerVisible = true
      this.recruitDetailsObj = data
    },
    // 获取头部banner
    async getBanners() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: '4',
      })
      if (res.code === 200) {
        // this.resBanners = [];
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl
        })
        // console.log(res.rows)
        this.resBanners = res.rows
        this.$nextTick(() => {
          this.$refs.cBanner.reInitBanner()
        })
      }
    },
    // 获取招聘信息
    async getDataList() {
      let res = await this.$request.getRecruitPage({
        type: this.navindex,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      // let dataList = [];
      if (res.code === 200) {
        this.recruitList = res.rows
        this.total = res.total
      }
      console.log(res, this.recruitList)
    },
    async getPage(page) {
      // 获取第 page 页数据
      // console.log(page);
      this.pageNo = page
      this.getDataList()
    },
  },
  components: {
    tooltip,
    Banner,
    recruitTit,
  },
}
</script>

<style lang="scss" scoped>
.recruit {
  .agency_line {
    margin-top: 1.56vw;
  }

  .agency_txt {
    width: 49.22vw;
    min-height: 10.68vw;
    background-color: #ffffff;
    box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(0, 0, 0, 0.08);
    color: #666666;
    font-size: 0.83vw;
    line-height: 1.56vw;
    padding: 1.56vw;
    box-sizing: border-box;
    float: left;

    p {
      text-indent: 1.82vw;
    }
  }

  .agency_img {
    width: 21.61vw;
    height: 10.68vw;
    float: left;
    margin-left: 2.08vw;
    overflow: hidden;
    background-color: #87c31e;
  }

  .recruitingNav {
    margin-top: 1.56vw;

    li {
      width: 7.81vw;
      height: 1.98vw;
      text-align: center;
      line-height: 1.98vw;
      display: inline-block;
      margin-right: 1.04vw;
      border: 0.05vw solid #87c31e;
      font-size: 0.94vw;
      color: #87c31e;
      cursor: pointer;

      &.on {
        background: #87c31e;
        color: #fff;
      }
    }
  }

  .recruitlist {
    li {
      width: 35.68vw;
      height: 8.8vw;
      cursor: pointer;
      padding: 1.56vw 2.08vw;
      float: left;
      box-sizing: border-box;
      position: relative;
      background-color: #ffffff;
      box-shadow: 0vw 0.1vw 0.42vw 0vw rgba(0, 0, 0, 0.08);
      margin-bottom: 1.56vw;

      &::after {
        display: block;
        content: '';
        position: absolute;
        width: 0.99vw;
        height: 1.41vw;
        background-color: #87c31e;
        top: 0;
        left: 0;
      }

      &:nth-child(2n + 2) {
        margin-left: 1.56vw;
      }

      &:hover {
        background: #87c31e;
        color: #fff;
      }

      &:hover .recruitlist_name,
      &:hover .recruitlist_btm .recruitlist_btm_right,
      &:hover .recruitlist_btm .recruitlist_btm_left,
      &:hover .recruitlist_line .recruitlist_line_p span,
      &:hover .recruitlist_line {
        color: #fff;
      }

      &:hover
        .recruitlist_btm
        .recruitlist_btm_right
        .recruitlist_btm_right_jt {
        background: url(../assets/images/recruit/jtbai.png) left center
          no-repeat;
        background-size: 100%;
      }

      .recruitlist_name {
        color: #83bb26;
        font-size: 0.94vw;
      }

      .recruitlist_line {
        margin-top: 1.04vw;
        font-size: 0.94vw;
        color: #999999;

        .recruitlist_line_p {
          display: inline-block;
          width: 33.3%;

          span {
            color: #333;
          }

          &:nth-child(2) {
            text-align: center;
          }

          &:nth-child(3) {
            text-align: right;
          }
        }
      }

      .recruitlist_btm {
        margin-top: 2.08vw;

        .recruitlist_btm_left {
          color: #666666;
          font-size: 0.73vw;
          display: inline-block;
          float: left;
        }

        .recruitlist_btm_right {
          color: #83bb26;
          font-size: 0.73vw;
          display: inline-block;
          float: right;

          .recruitlist_btm_right_jt {
            width: 1.82vw;
            height: 0.83vw;
            display: inline-block;
            margin-left: 0.26vw;
            background: url(../assets/images/recruit/jtlu.png) left center
              no-repeat;
            background-size: 100%;
          }
        }
      }
    }
  }

  .dialog-header {
    width: 100%;
    height: 2.6vw;
    line-height: 2.6vw;
    padding: 0;
    background-color: #87c31e;
    color: #fff;
    padding-left: 3.13vw;
    box-sizing: border-box;
    font-size: 0.94vw;
    .zpname {
      display: inline-block;
    }
    .zprecruitCount {
      display: inline-block;
      margin-left: 4.17vw;
    }
  }
  .dialog_content {
    padding: 0 2.08vw;
    box-sizing: border-box;
    .dialog_tit {
      width: 4.43vw;
      height: 1.56vw;
      line-height: 1.56vw;
      text-align: center;
      color: #fff;
      font-size: 0.83vw;
      background-color: #87c31e;
    }
    .dialog_txt {
      color: #333333;
      font-size: 0.83vw;
      line-height: 1.56vw;
      margin-top: 1.04vw;
      .dialog_b_txt {
        display: inline-block;
        &:nth-child(1) {
          width: 11.46vw;
        }
        &:nth-child(2) {
          width: 6.25vw;
          margin-left: 1.56vw;
          margin-right: 1.41vw;
        }
        &:nth-child(3) {
          width: 10.42vw;
        }
      }
    }
  }
  .pagecon {
    text-align: center;
    padding: 1.04vw 0;
  }
}

@media (min-width: 1920px) {
  .recruit {
    .agency_line {
      margin-top: 30px;
    }

    .agency_txt {
      width: 945px;
      min-height: 205px;
      background-color: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      color: #666666;
      font-size: 16px;
      line-height: 30px;
      padding: 30px;
      box-sizing: border-box;
      float: left;

      p {
        text-indent: 35px;
      }
    }

    .agency_img {
      width: 415px;
      height: 205px;
      float: left;
      margin-left: 40px;
      overflow: hidden;
      background-color: #87c31e;
    }

    .recruitingNav {
      margin-top: 30px;

      li {
        width: 150px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        display: inline-block;
        margin-right: 20px;
        border: 1px solid #87c31e;
        font-size: 18px;
        color: #87c31e;
        cursor: pointer;

        &.on {
          background: #87c31e;
          color: #fff;
        }
      }
    }

    .recruitlist {
      .notRecruit {
        color: #999;
      }
      li {
        width: 685px;
        height: 169px;
        cursor: pointer;
        padding: 30px 40px;
        float: left;
        box-sizing: border-box;
        position: relative;
        background-color: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
        margin-bottom: 30px;

        &::after {
          display: block;
          content: '';
          position: absolute;
          width: 19px;
          height: 27px;
          background-color: #87c31e;
          top: 0;
          left: 0;
        }

        &:nth-child(2n + 2) {
          margin-left: 30px;
        }

        &:hover {
          background: #87c31e;
          color: #fff;
        }

        &:hover .recruitlist_name,
        &:hover .recruitlist_btm .recruitlist_btm_right,
        &:hover .recruitlist_btm .recruitlist_btm_left,
        &:hover .recruitlist_line .recruitlist_line_p span,
        &:hover .recruitlist_line {
          color: #fff;
        }

        &:hover
          .recruitlist_btm
          .recruitlist_btm_right
          .recruitlist_btm_right_jt {
          background: url(../assets/images/recruit/jtbai.png) left center
            no-repeat;
          background-size: 100%;
        }

        .recruitlist_name {
          color: #83bb26;
          font-size: 18px;
        }

        .recruitlist_line {
          margin-top: 20px;
          font-size: 18px;
          color: #999999;

          .recruitlist_line_p {
            display: inline-block;
            width: 33.3%;

            span {
              color: #333;
            }

            &:nth-child(2) {
              text-align: center;
            }

            &:nth-child(3) {
              text-align: right;
            }
          }
        }

        .recruitlist_btm {
          margin-top: 40px;

          .recruitlist_btm_left {
            color: #666666;
            font-size: 14px;
            display: inline-block;
            float: left;
          }

          .recruitlist_btm_right {
            color: #83bb26;
            font-size: 14px;
            display: inline-block;
            float: right;

            .recruitlist_btm_right_jt {
              width: 35px;
              height: 16px;
              display: inline-block;
              margin-left: 5px;
              background: url(../assets/images/recruit/jtlu.png) left center
                no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }

    .dialog-header {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0;
      background-color: #87c31e;
      color: #fff;
      padding-left: 60px;
      box-sizing: border-box;
      font-size: 18px;
      .zpname {
        display: inline-block;
      }
      .zprecruitCount {
        display: inline-block;
        margin-left: 80px;
      }
    }
    .dialog_content {
      padding: 0 40px;
      box-sizing: border-box;
      .dialog_tit {
        width: 85px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        background-color: #87c31e;
      }
      .dialog_txt {
        color: #333333;
        font-size: 16px;
        line-height: 30px;
        margin-top: 20px;
        .dialog_b_txt {
          display: inline-block;
          &:nth-child(1) {
            width: 220px;
          }
          &:nth-child(2) {
            width: 120px;
            margin-left: 30px;
            margin-right: 27px;
          }
          &:nth-child(3) {
            width: 200px;
          }
        }
      }
    }
    .pagecon {
      text-align: center;
      padding: 1.04vw 0;
    }
  }
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.pagecon /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #83bb26;
  color: #fff;
}

.pagecon /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #83bb26;
}
</style>
